import React, { useState } from 'react'
import cn from 'classnames'
import { useTranslation } from 'react-i18next'

import styles from './styles.module.scss'

import TrashIcon from '../../Icons/TrashIcon'
import EditIcon from '../../Icons/EditIcon'

const FolderItem = ({folder, isSelected, canManage, onCancel, onSubmit, onEdit, onRemove, onSelect}) => {
  const { t } = useTranslation()
  const [form, setForm] = useState({title: folder.name || '', description: folder.description || ''})
  const handleChangeForm = (field) => ({target: {value}}) => {
    setForm(prev => ({...prev, [field]: value}))
  }

  const handleSubmit = () => {
    if (!form.title) {
      return
    }
    onSubmit({...folder, name: form.title, description: form.description})
  }

  const handleCancel = () => {
    setForm({title: folder.name, description: folder.description})
    onCancel(folder.id)
  }

  
  const handleEdit = (e) => {
    e.stopPropagation()
    onEdit(folder.id)
  }

  const handleRemove = (e) => {
    e.stopPropagation()
    onRemove(folder)
  }

  const handleSelect = () => {
    if (folder.editable) {
      return
    }
    onSelect(folder.id)
  }

  return (
    <div className={cn(styles.container, {[styles.editable]: folder.editable, [styles.selected]: isSelected})} onClick={handleSelect}>
      {
        folder.editable
          ? <>
              <input
                type="text"
                placeholder={t('Folder name')}
                autoFocus={true}
                value={form.title}
                onChange={handleChangeForm('title')}
                className={styles.inputTitle} />
              <input
                type="text"
                placeholder={t('Description (optional)')}
                value={form.description}
                onChange={handleChangeForm('description')}
                className={styles.inputDescription} />
              <div className={styles.editActions}>
                <div className={cn(styles.actionButton, styles.success)} onClick={handleSubmit}>{folder.id ? t('Update') : t('Create')}</div>
                <div className={cn(styles.actionButton, styles.cancel)} onClick={handleCancel}>{ t('Cancel') }</div>
              </div>
            </>
          : <div className={styles.content}>
              <div style={{flex: 1}}>
                <div className={styles.title}>{folder.name}</div>
                {
                  folder.assign_employees_count
                    ? <div className={styles.counts}>{folder.assign_employees_count} {t('reviewers')}</div>
                    : null
                }
                <div className={styles.counts}>{folder.documents_count} {t('documents')}</div>
              </div>
              {
                canManage
                  ? <div className={styles.manageActions}>
                      <div className={styles.actionButton} onClick={handleEdit}>
                        <EditIcon />
                      </div>
                      <div className={cn(styles.actionButton, styles.delete)} onClick={handleRemove}>
                        <TrashIcon />
                      </div>
                    </div>
                  : null
              }
            </div>
      }
    </div>
  )
}

export default FolderItem